var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"chart-section-header"},[_vm._v(_vm._s(_vm.sectionTitle))]),_c('div',{staticClass:"chart-section-body"},[_vm._t("chart")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }